import React from 'react';
import './decorations.scss';
import helecho from './assets/helecho.png';
import hojaPalmera from './assets/hoja-palmera.png';
import hojaHelecho from './assets/hoja-helecho.png';


class Decorations extends React.Component {

  render() {
    return (
      <div className="decorations">
        <img className="hojaPalmera" src={hojaPalmera} alt="vegetación" />
        <img className="hojaHelecho2" src={hojaHelecho} alt="vegetación" />
        <img className="helecho" src={helecho} alt="vegetación" />
        <img className="hojaPalmera2" src={hojaPalmera} alt="vegetación" />
        <img className="hojaPalmera3" src={hojaPalmera} alt="vegetación" />
        <img className="hojaHelecho" src={hojaHelecho} alt="vegetación" />
        <img className="hojaHelecho3" src={hojaHelecho} alt="vegetación" />
      </div>
    );
  }
}

export default Decorations;
